// Email-Templates für das Onboarding-Modul.
//
// WICHTIG: Wir senden KEINE E-Mails serverseitig (kein SMTP). Die Templates
// werden im UI gerendert und von HR per Copy-and-paste in das eigene
// E-Mail-Programm (Outlook / Apple Mail) übernommen. Begründung (Locked D6):
// einfacher Stack, keine SMTP-Konfiguration, vollständige Kontrolle der
// Absenderadresse beim HR-Mitarbeiter.

export type ProbearbeiterDecisionTemplateInput = {
  vorname: string
  nachname: string
  schule: string | null
  probeVon: string  // ISO-Datum
  probeBis: string  // ISO-Datum
  hrName: string    // Absender:in (z. B. "Anke Schmidt")
  hrTitel?: string  // optional
  /** Frei editierbarer Begründungs-Block (HR füllt aus). Nur bei Reject genutzt. */
  rejectionReason?: string
  /** Bei Annahme: Vertragsstart, falls bekannt. */
  vertragsBeginn?: string | null
}

function fmtDate(iso: string): string {
  if (!iso) return ''
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function renderRejectionEmail(p: ProbearbeiterDecisionTemplateInput): { subject: string; body: string } {
  const subject = `Rückmeldung zu Ihrer Probearbeit bei Mammas Canteen`
  const greeting = p.vorname ? `Liebe/r ${p.vorname},` : 'Sehr geehrte/r Bewerber/in,'
  const reasonBlock = p.rejectionReason && p.rejectionReason.trim().length > 0
    ? `\n${p.rejectionReason.trim()}\n`
    : ''
  const schule = p.schule ? ` an der ${p.schule}` : ''
  const dates = `${fmtDate(p.probeVon)}${p.probeBis && p.probeBis !== p.probeVon ? `–${fmtDate(p.probeBis)}` : ''}`

  const body = [
    greeting,
    '',
    `vielen Dank, dass Sie sich die Zeit genommen haben, am ${dates} im Rahmen einer Probearbeit Teil unseres Teams${schule} zu sein.`,
    '',
    'Nach sorgfältiger Abwägung haben wir uns entschieden, Sie für die ausgeschriebene Position aktuell nicht zu berücksichtigen.',
    reasonBlock,
    'Wir wünschen Ihnen für Ihren weiteren beruflichen Weg viel Erfolg und Gesundheit.',
    '',
    'Mit freundlichen Grüßen',
    p.hrName + (p.hrTitel ? ` (${p.hrTitel})` : ''),
    'Mammas Canteen GmbH',
  ].filter(Boolean).join('\n')

  return { subject, body }
}

export function renderAcceptanceEmail(p: ProbearbeiterDecisionTemplateInput): { subject: string; body: string } {
  const subject = `Willkommen im Team — nächste Schritte für Ihren Start bei Mammas Canteen`
  const greeting = p.vorname ? `Liebe/r ${p.vorname},` : 'Sehr geehrte/r neue/r Mitarbeiter/in,'
  const startLine = p.vertragsBeginn
    ? `wir freuen uns sehr, Ihnen mitteilen zu können, dass Sie ab ${fmtDate(p.vertragsBeginn)} Teil unseres Teams${p.schule ? ` an der ${p.schule}` : ''} werden!`
    : `wir freuen uns sehr, Ihnen mitteilen zu können, dass Sie zum nächstmöglichen Zeitpunkt Teil unseres Teams${p.schule ? ` an der ${p.schule}` : ''} werden!`

  const body = [
    greeting,
    '',
    startLine,
    '',
    'Damit wir Sie sauber aufnehmen können, brauchen wir noch einige Unterlagen von Ihnen:',
    '',
    '  • Steueridentifikationsnummer',
    '  • Sozialversicherungsnummer + Krankenkasse',
    '  • Bankverbindung (IBAN)',
    '  • Gesundheitszeugnis (Belehrung nach §43 IfSG)',
    '  • Masernimpfnachweis',
    '  • Bei Nicht-EU-Bürgern: Aufenthaltstitel + Arbeitserlaubnis',
    '',
    'Bitte senden Sie diese an: hr@mammascanteen.de oder bringen Sie sie zum ersten Arbeitstag mit.',
    '',
    'Wir melden uns in den kommenden Tagen mit den weiteren Schritten und Ihrem Vertrag.',
    '',
    'Herzlich willkommen!',
    '',
    p.hrName + (p.hrTitel ? ` (${p.hrTitel})` : ''),
    'Mammas Canteen GmbH',
  ].join('\n')

  return { subject, body }
}
